import { render } from "./AppMenuItem.vue?vue&type=template&id=69325865&scoped=true"
import script from "./AppMenuItem.vue?vue&type=script&lang=js"
export * from "./AppMenuItem.vue?vue&type=script&lang=js"

import "./AppMenuItem.vue?vue&type=style&index=0&id=69325865&lang=scss&scoped=true"

import exportComponent from "/Users/dmytrokulyk/Documents/Development/GreenHub/dsp-f-2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69325865"]])

export default __exports__